module.exports = __webpack_public_path__ + "img/celular-station.03424d9f.png";